import { lazy } from 'react';

/**
 * Lazy-loaded component for the main application for an __❌ unauthenticated__ user.
 */
export const AnonymousMain = lazy(() => import('./AnonymousMain'));
export { AnonymousMain as default };
